import { render, staticRenderFns } from "./newDiagnosis.vue?vue&type=template&id=39f9f69e&scoped=true&"
import script from "./newDiagnosis.vue?vue&type=script&lang=js&"
export * from "./newDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./newDiagnosis.vue?vue&type=style&index=0&id=39f9f69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9f69e",
  null
  
)

export default component.exports